import { render, staticRenderFns } from "./PurchaseRequest.vue?vue&type=template&id=4769a25f&scoped=true&"
import script from "./PurchaseRequest.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequest.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequest.vue?vue&type=style&index=0&id=4769a25f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4769a25f",
  null
  
)

export default component.exports